/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationTenResponse {
    getFixupPrototypeFunction() { return CostOptimizationTenResponse.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationTenResponse>): CostOptimizationTenResponse {
        let obj = Object.assign(new CostOptimizationTenResponse(), model);
        CostOptimizationTenResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationTenResponse>): CostOptimizationTenResponse {
        if (!model) return null;
        return CostOptimizationTenResponse.newInstance(<CostOptimizationTenResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationTenResponse) {
        if (!obj) return;

        models.CostOptimizationTenResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationTenResponse): boolean {
        Object.setPrototypeOf(obj, CostOptimizationTenResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Response status on tenant details
     */
    status: string;

    /**
     * Listing tenants data retrieved successfully
     */
    message: string;

    /**
     * tenant details
     */
    tenant: any;

}
